import { DataGrid } from "devextreme-react";
import { Scrolling } from "devextreme-react/data-grid";
import React, { useEffect, useRef } from "react";

function KpiTable(props){
    const {dataSource, columns, showHeaders, isLoadingData} = props;
    const table = useRef(null);

    useEffect(()=>{
            const tableRef = table.current;
            if(tableRef){
                if(isLoadingData){
                    tableRef.instance.beginCustomLoading("Cargando")
                } else {
                tableRef.instance.endCustomLoading()
                }
            } 
    },[isLoadingData])

    return(
        <div>
            <DataGrid
            height={340}
            ref={table}
            showColumnHeaders={showHeaders}
            rowAlternationEnabled={false}
            showColumnLines={false}
            showRowLines={true}
            loadPanel={{text: "Cargando"}}
            showBorders={false}     
            dataSource={dataSource}
            >
            { columns.map((value,index) => {return value;}) }
                <Scrolling mode="infinite" />
            </DataGrid>
        </div>

    )
}

export {KpiTable}